<template>
  <div>

    <b-message
      title="Info"
      type="is-info"
      aria-close-label="Close message"
    >
      Для того, чтобы выгрузить детализированный отчёт по кампании необходимо выбрать стартовую и конечную даты,
      кампанию и нажать "Отправить запрос".
      По готовности отчёта будет отправлено письмо. Так же результат можно будет посмотреть в релевантной карточке
      детализации на данной странице.
    </b-message>

    <b-field label="Select start period date">
      <b-datepicker
        rounded
        size="is-medium"
        placeholder="Click to select..."
        v-model="startPeriodDate"
        :max-date=getCurrentDate()
      >
      </b-datepicker>
    </b-field>

    <b-field label="Select end period date">
      <b-datepicker
        rounded
        size="is-medium"
        placeholder="Click to select..."
        v-model="endPeriodDate"
        :max-date=getCurrentDate()
      >
      </b-datepicker>
    </b-field>

    <b-field
      v-if="campaignsList"
      label="Campaign"
    >
      <b-select
        placeholder="Select a campaign"
        rounded
        required
        expanded
        size="is-medium"
        v-model="selectedCampaign"
      >
        <option
          v-for="campaign in campaignsList"
          :value="campaign.id"
          :key="campaign.id"
        >
          {{ campaign.name }}
        </option>
      </b-select>
    </b-field>

    <p class="control">
      <button
        class="button is-primary"
        v-on:click="sendGenerateDetailsReportRequest()"
        :disabled="!!loading"
      >
        <span class="icon">
          <i class="fa fa-paper-plane"></i>
        </span>
        <span>Отправить запрос</span>
      </button>
    </p>

    <div
      class="reports-container"
      v-if="detailsReportsPage && detailsReportsPage.content"
    >
      <div
        class="report-card"
        v-for="(detailsReport) in detailsReportsPage.content"
        :key="detailsReport.id"
      >
        <div class="report-card-title">
          <h2> №{{ detailsReport.id }} </h2>
          <span
            class="report-card-status"
            :class="getStatusClass(detailsReport.status)"
          >{{ detailsReport.status }}</span>
        </div>

        <div class="report-card-details">
          <div class="report-card-details-item">
            Кампания : {{ detailsReport.campaignName }}
          </div>
          <div class="report-card-details-item">
            Начало периода выгрузки : {{ detailsReport.startDatePeriod }}
          </div>

          <div class="report-card-details-item">
            Конец периода выгрузки : {{ detailsReport.endDatePeriod }}
          </div>

          <div class="report-card-details-item">
            Дата создания запроса : {{
              getDateFormat((detailsReport.createdTimestamp / 1000) < 1000000000000 ? detailsReport.createdTimestamp : detailsReport.createdTimestamp / 1000)
            }}
          </div>

          <div
            class="report-card-details-item"
            v-if="detailsReport.finishedTimestamp"
          >
            Запрос обработан : {{
              getDateFormat((detailsReport.finishedTimestamp / 1000) < 1000000000000 ? detailsReport.finishedTimestamp : detailsReport.finishedTimestamp / 1000)
            }}
          </div>

          <div class="report-card-details-item">
            Прогресс выполнения отчёта :
          </div>
        </div>

        <div class="report-card-progress">
          <b-progress
            size="is-large"
            :type="getProgressType(detailsReport.progress)"
            :value="detailsReport.progress"
            show-value
            format="percent"
          ></b-progress>
        </div>

        <a
          target="_blank"
          rel="noopener noreferrer"
          class="report-card-button"
          v-if="detailsReport.status === 'SUCCESS'"
          v-bind:href="detailsReport.hostPathToReport"
        > Скачать отчёт </a>

      </div>

      <div class="paging-bottom">
        <Paging
          :refresh="loadDetailsReportsPage"
          :per-page="perPage"
          :data.sync="detailsReportsPage"
          :pagingClass="'bottom'"
        />
      </div>

    </div>

  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import VisCommon from '../components/VisCommon'
import Paging from '../components/Paging'

const _MS_PER_DAY = 1000 * 60 * 60 * 24
const CAMPAIGN_API = '/api/campaigns'
const BILLING_API = 'billing/details'

export default {
  name: 'BillingDetails',
  extends: VisCommon,
  components: {
    Paging
  },

  data() {
    return {
      loading: false,
      startPeriodDate: [],
      endPeriodDate: [],
      campaignsList: [],
      selectedCampaign: '',
      detailsReportsPage: {content: []},
      currentSort: 'createdTimestamp',
      currentSortDir: 'desc',
      perPage: 8
    }
  },

  created: function () {
    this.loadCampaignsList()
    this.loadDetailsReportsPage()
  },

  computed: {
    ...mapGetters([
      'authenticationToken',
      'clientId'
    ])
  },

  methods: {
    prepareSecurityHeader() {
      return {
        Authorization: `Bearer ${this.authenticationToken}`
      }
    },

    loadCampaignsList() {
      let that = this
      that.loading = true
      this.$http.get(CAMPAIGN_API + '/listByClient', {headers: this.prepareSecurityHeader()})
        .then((response) => {
          that.loading = false
          that.campaignsList = response.data.response
        })
        .catch((error) => {
          that.loading = false
          console.log(error)
          that.openNotificationWithType('danger', 'Ошибка загрузки кампаний клиента.')
        })
    },

    sendGenerateDetailsReportRequest() {
      if (!this.validateInputs()) {
        return
      }
      let that = this
      that.loading = true
      this.$http.post(BILLING_API + '/create' + '?campaignId=' + this.selectedCampaign + '&startDatePeriod=' + this.formatDateToStr(this.startPeriodDate) + '&endDatePeriod=' + this.formatDateToStr(this.endPeriodDate), {}, {headers: this.prepareSecurityHeader()})
        .then((response) => {
          that.loading = false

          if (response.data.response) {
            that.openNotificationWithType('info', 'Запрос на детализацию успешно создан.')
          }
          that.loadDetailsReportsPage()
        })
        .catch((error) => {
          that.loading = false
          console.log(error)
          that.openNotificationWithType('danger', 'Ошибка создания запроса детализации.')
        })
    },

    loadDetailsReportsPage(page) {
      let that = this
      this.loading = true
      page = page ? (page - 1) : 0
      let url = BILLING_API + '/getReports' + '?page=' + page + '&pageSize=' + this.perPage + '&sortDir=' + this.currentSortDir + '&sort=' + this.currentSort
      this.$http.get(url, {headers: this.prepareSecurityHeader()})
        .then((response) => {
          that.loading = false
          that.detailsReportsPage = response.data.response
        })
        .catch((error) => {
          that.loading = false
          console.log(error)
          that.openNotificationWithType('danger', 'Ошибка загрузки списка детализаций. ')
        })
    },

    validateInputs() {
      if (!Date.parse(this.startPeriodDate) || !Date.parse(this.endPeriodDate) || this.selectedCampaign === '') {
        this.openNotificationWithType('danger', 'Не выбраны периоды дат или кампания.')
        return false
      }

      let difference = this.dateDiffInDays(this.startPeriodDate, this.endPeriodDate)

      if (difference < 1) {
        this.openNotificationWithType('danger', 'Ошибка: конечная дата должна быть больше, чем стартовая и разница между ними должна быть равна хотя бы одному дню')
        return false
      }

      if (difference > 30) {
        this.openNotificationWithType('danger', 'Ошибка: Разница между датами не должна первышать 30 дней')
        return false
      }

      return true
    },

    dateDiffInDays(a, b) {
      // Discard the time and time-zone information.
      const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate())
      const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate())

      return Math.floor((utc2 - utc1) / _MS_PER_DAY)
    },

    getCurrentDate: function () {
      var date = new Date()
      return date
    },

    // dd.mm.yyyy
    formatDateToStr(date) {
      var d = date.getDate()
      var m = date.getMonth() + 1
      var y = date.getFullYear()

      var dateString = (d <= 9 ? '0' + d : d) + '.' + (m <= 9 ? '0' + m : m) + '.' + y

      return dateString
    },

    isEmpty(obj) {
      return Object.keys(obj).length === 0
    },

    getProgressType(progress) {
      if (progress == 0) {
        return 'is-warning'
      }
      if (progress == 100) {
        return 'is-success'
      }

      return 'is-info'
    },

    getStatusClass: function (status) {
      if (status === 'SUCCESS') {
        return 'status-success'
      } else if (status === 'PENDING') {
        return 'status-pending'
      } else if (status === 'READY') {
        return 'status-ready'
      }
    }
  }
}
</script>

<style lang="css" scoped>
.button.is-primary {
  width: 100%;
  text-align: center;
  height: 50px;
  border-radius: 30px;

  margin-bottom: 5rem;
}

.reports-container {
  margin-top: 3rem;
  max-width: 100%;
  padding: 0 2rem;
  margin: auto;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-items: center;
  text-align: center;
}

.report-card {
  padding: 0 1rem;
  display: flex;
  flex-direction: column;
  text-align: center;
  box-shadow: 0px 2px 10px -4px rgba(0, 0, 0, 0.3);
  border-radius: 15px;
  min-height: 20rem;
  margin-bottom: 2rem;
}

.report-card-title {
  margin-top: 1rem;
  display: flex;
  justify-content: space-between;
}

.report-card-title h2 {
  text-align: left;
  font-weight: 600;
}

.report-card-status {
  margin-right: 0.5rem;
  padding-top: 3px;
  font-size: 0.8rem;
  min-height: 20px;
  min-width: 80px;
  border-radius: 20px;
  box-shadow: 0px 2px 10px -4px rgba(0, 0, 0, 0.3);
}

.status-ready {
  background-color: #fac7d3;
}

.status-pending {
  background-color: #ffedc2;
}

.status-success {
  background-color: #c3fdee;
}

.report-card-details {
  margin-top: 2rem;
  display: flex;
  flex-direction: column;
  text-align: left;
}

.report-card-details-item {
  margin-bottom: 0.5rem;
}

.report-card-progress {
  margin-top: 0.5rem;
}

.report-card-button {
  margin-top: -1rem;
  margin-bottom: 1.5rem;
  padding-top: 6px;
  min-height: 2.5rem;
  background-color: #effaf5;

  border-radius: 15px;
}

.progress-wrapper:not(:last-child) {
  margin-bottom: 0.2rem;
}
</style>>



// WEBPACK FOOTER //
// BillingDetails.vue?430ee868